import { useState, useEffect } from "react";

/**
 * Custom hook that debounces a value.
 * @param value - The value to debounce
 * @param delay - Delay in milliseconds (default is 300ms)
 * @returns Debounced value
 */
const useDebounce = (value, delay = 300) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

export default useDebounce;
